<template>
  <h1>Observations</h1>
  <div class="grid-table">
    <template v-for="[date, list] of observationsPerDay.entries()" :key="date">
      <div class="table-day-line">{{ date }}</div>
      <template v-for="d in list" :key="d.id">
        <Observation :measurement-definition="def(d)" :observation="d" />
      </template>
    </template>
  </div>
  <div>
    <v-text-field
      v-model="newTextObservation"
      density="compact"
      label="new text observation"
      @change="enterText"
    />
  </div>
  <div v-if="data2">
    <v-select
      v-model="measurementDefinition"
      item-title="definition.name"
      item-value="definition.name"
      :items="data2.data"
      label="Measurement definition"
      required
      return-object
    />
  </div>
  <div v-if="measurementDefinition">
    <CreateMeasurement
      :initial-value="measurementDefinition.latest?.significand"
      :measurement-definition="measurementDefinition.definition"
      @create="createMeasurement"
    />
  </div>
</template>
<script setup lang="ts">
import { useQueryClient } from "@tanstack/vue-query";
import {
  type Measurement,
  type MeasurementDefinitionWithLatestMeasurement,
  type Observation,
  useMeasurementDefinitionsLatest,
  useObservationsCreate,
  useObservationsList,
} from "../gen/observations-vue";
import { computed, ref, type Ref } from "vue";
import { v7 as uuidv7 } from "uuid";
import { uuidV7ToTimestamp } from "@/utils";

const newTextObservation = ref("");
const measurementDefinition: Ref<MeasurementDefinitionWithLatestMeasurement | null> =
  ref(null);

const { data, queryKey } = useObservationsList({
  query: { placeholderData: (prev) => prev },
});

const { data: data2 } = useMeasurementDefinitionsLatest({
  query: { placeholderData: (prev) => prev },
});

const { mutate: create } = useObservationsCreate({
  mutation: {
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey });
    },
  },
});

const observationsPerDay: Ref<Map<string, Observation[]>> = computed(() => {
  const map = new Map<string, Observation[]>();
  if (!data.value?.data) {
    return map;
  }
  for (const observation of data.value.data) {
    const date = uuidV7ToTimestamp(observation.id).toISOString().slice(0, 10);
    const list = map.get(date);
    if (list === undefined) {
      map.set(date, [observation]);
    } else {
      list.push(observation);
    }
  }
  return map;
});

const queryClient = useQueryClient();
function enterText() {
  if (newTextObservation.value) {
    create({
      data: { id: uuidv7(), data: { Text: newTextObservation.value } },
    });
    newTextObservation.value = "";
  }
}
function createMeasurement(measurement: Measurement) {
  const id = uuidv7();
  create({
    data: {
      id,
      data: {
        Measurement: measurement,
      },
    },
  });
  measurementDefinition.value = null;
}

function def(
  observation: Observation,
): MeasurementDefinitionWithLatestMeasurement | undefined {
  if ("Measurement" in observation.data) {
    const definition = observation.data.Measurement.definition;
    return data2.value?.data.find((md) => md.definition.id === definition);
  }
  console.log("u");
  return;
}
</script>
<style scoped>
div.grid-table {
  display: grid;
  grid-template-columns: 1fr 20fr 1fr 1fr 1fr;
}
.table-day-line {
  font-weight: bold;
  grid-column-start: 0;
  grid-column-end: span 5;
}
</style>
